/* eslint-disable react/react-in-jsx-scope */
import { Component } from "react";
import { readLang } from "./languages.js";
import langs from "./langs/langs.js";
const TranslateFunction = text => {
  const actuallang = readLang();
  if (!text || !langs["es"][text]) return null;
  return actuallang ? langs[actuallang][text] : langs["es"][text];
};

class Translate extends Component {
  state = {};
  render() {
    const actuallang = readLang();
    if (!this.props.text || !langs["es"][this.props.text]) return null;
    return actuallang
      ? `${langs[actuallang][this.props.text]}  `
      : `${langs["es"][this.props.text]}  `;
  }
}

export { Translate, TranslateFunction };
